import moment from 'moment';
import React from 'react';
import Modal from '../../Components/Modal/Modal';
import StatusBadge from '../../Components/StatusBadge/StatusBadge';
import Table from '../../Components/Table/Table';
import { convertCost } from '../../Utils/functions';
import './SMSHistory.scss';

const statusList = {
    Pending : '쿠폰포함',
    Done : '쿠폰미포함'
}

const variant = {
    Pending : 'primary',
    Done : 'normal'
}

const SMSHistory = () => {
    const modalRef = React.useRef(null);
    const [ data, setData ] = React.useState({})

    const columnsSMS = React.useMemo(
        () => [
          {
            /* Header: '문자제목을 검색해보세요.', */
            Header: '문자제목',
            accessor: 'Title', // accessor is the "key" in the data
            disableSortBy : true,
            Cell : (props) => {
              return (
                <p className='table-title'>{props.cell.value}</p>
              )
            },
            width : 340,
            minWidth : 340
          },
          {
            Header: '발송건수',
            accessor: 'ReqCount',
            disableFilters : true,
            minWidth : 100,
            maxWidth : 100,
            width : 100,
            Cell : (props) => {
                return(
                    <p>{convertCost(props.cell.value)} 건</p>
                )
            }
          },
          {
            Header: '발송일시',
            accessor: 'Date.$date',
            disableFilters : true,
            minWidth : 150,
            width : 150,
            Cell : (props) => {
                return(
                    <p>{moment(props.cell.value).utc().locale('ko').format('YY-MM-DD(dd) HH:mm:ss')}</p>
                )
            }
          },
          {
            Header: '발송자',
            accessor: 'Sender',
            disableSortBy : true,
            minWidth : 140,
            width : 140,
            Cell : (props) => {
                return(
                    <p>{props.cell.value === 'Auto' ? '자동 발송' : props.cell.value === 'Manual' ? '점주 수동 발송' : '본사 발송'}</p>
                )
            }
          },
          {
            Header: '쿠폰여부',
            accessor: 'Coupon',
            disableFilters : true,
            isDropdown : true,
            options : [
              { key : 'test1' , value : 'Ccc11'},
              { key : 'test2' , value : '22'},
              { key : 'test3' , value : '33'},
              { key : 'test4' , value : '44'},
            ],
            Cell : (props) => {
                return(
                    <StatusBadge Status={statusList[typeof props.cell.value === 'undefined' ? 'Done' : 'Pending']} variant={variant[typeof props.cell.value === 'undefined' ? 'Done' : 'Pending']}/>
                )
            },
            minWidth : 140,
            width : 140
          },
        ]
    )

    return (
        <div className='sms-history'>
            <Table key={'sms'} url={'/api/history/sms'} columns={columnsSMS} onRowClick={(data) => { setData(data);modalRef.current.openModal();}}/>
            <Modal ref={modalRef} contentContainer={{width : 600 }} isHeader title={`문자 상세 내역을\n확인해보세요.`}>
                <div >
                    {
                        Object.keys(data).length > 0 &&
                        <>
                            <div className='modal-row'>
                                <div>
                                    <div className='modal-row'>
                                        <p className='info-title'>발송일시</p>
                                        <p className='info-text'>{moment(data.Date.$date).utc().locale('ko').format('YY-MM-DD(dd) HH:mm:ss')}</p>
                                    </div>

                                    <div className='modal-row between'>
                                        <p className='info-title'>발송자</p>
                                        <p className='info-text'>{data.Sender === 'Auto' ? '자동 발송' : data.Sender === 'Manual' ? '점주 수동 발송' : '본사 발송'}</p>
                                    </div>
                                </div>
                                <div className='line' />
                                <div>
                                    <div className='modal-row'>
                                        <p className='info-title'>발송건수</p>
                                        <p className='info-text'>{convertCost(data.ReqCount)}</p>
                                    </div>

                                    <div className='modal-row between'>
                                        <p className='info-title'>발송자</p>
                                        <p className='info-text'>{convertCost(data.ReqCount)}</p>
                                    </div>
                                </div>
                            </div>

                            <div className='modal-row' style={{ marginTop : 32 }}>
                                <p className='info-title'>문자제목</p>
                                <p className='info-text'>{data.Title}</p>
                            </div>

                            <div className='modal-row'>
                                <p className='info-title'>문자내용</p>
                                <div className='text-area'>
                                    <p className='info-text'>{data.Body}</p>
                                </div>
                            </div>

                            <div className='modal-row' style={{ marginTop : 40 }}>
                                <p className='info-title'>쿠폰여부</p>
                                <StatusBadge Status={statusList[typeof data.Coupon === 'undefined' ? 'Done' : 'Pending']} variant={variant[typeof data.Coupon === 'undefined' ? 'Done' : 'Pending']}/>
                            </div>

                            {
                                typeof data.Coupon !== 'undefined' &&
                                <div className='coupon-box'>
                                    <div className='row'>
                                        {
                                            data.Coupon.Type === '상품증정' && <img src={require(`../../aseets/icons/coupon_gift.svg`).default} style={{ width : 40, height : 40, marginRight : 16 }} />
                                        }
                                        {
                                            data.Coupon.Type === '원 할인' && <img src={require(`../../aseets/icons/coupon_won.svg`).default} style={{ width : 40, height : 40, marginRight : 16 }} />
                                        }
                                        {
                                            data.Coupon.Type === '% 할인' && <img src={require(`../../aseets/icons/coupon_percent.svg`).default} style={{ width : 40, height : 40, marginRight : 16 }} />
                                        }
                                        {
                                            data.Coupon.Type === '1+1' && <img src={require(`../../aseets/icons/coupon_plus.svg`).default} style={{ width : 40, height : 40, marginRight : 16 }} />
                                        }
                                        <div>
                                            <p className='coupon-name'>{data.Coupon.Name}({data.Coupon.Type})</p>
                                            <p className='coupon-desc'>{data.Coupon.Description}</p>
                                        </div>
                                    </div>
                                </div>
                            }
                        </>
                    }
                </div>
            </Modal>
        </div>
    )
}

export default SMSHistory;